import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'are_wrkrs_trained_and_required_to_use_personal_prot_equipment_i'

export const dataPointDefinition = {
  retracedId: 'are_wrkrs_trained_and_required_to_use_personal_prot_equipment_i',
  name: 'Are workers trained and required to use personal protective equipment in line with legal requirements?',
  description:
    'To answer Yes, the facility must comply with all applicable laws on both worker training and requiring  workers to use  the provided protective equipment. \r\r\n\r\r\nConsult applicable legal requirements. \r\r\n\r\r\nIf there are no applicable legal requirements, answer No applicable legal requirements.\r\r\n\r\r\nIf workers do not require PPE answer Not Applicable. ',
  meta: {},
  fieldTypeId: 'SELECT_WITH_FOLLOW_UP',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'ynna-nalr',
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please describe the types of firefighting equipment used and in which areas of the facility the firefighting equipment is present:',
        externalIds: [
          {
            id: 'hs-31--1-5f',
            version: '1.6.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'ynna-nalr',
    },
    {
      name: 'Not Applicable',
      key: 'NOT_APPLICABLE',
      slcpIndex: 3,
      slcpOptionName: 'ynna-nalr',
    },
    {
      name: 'No applicable legal requirements',
      key: 'NO_APPLICABLE_LEGAL_REQS',
      slcpIndex: 4,
      slcpOptionName: 'ynna-nalr',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'object',
        properties: {
          value: {
            type: 'string',
            enum: ['YES', 'NO', 'NOT_APPLICABLE', 'NO_APPLICABLE_LEGAL_REQS'],
          },
          followUp: {
            type: ['object', 'null'],
            properties: {
              value: {
                type: 'string',
              },
            },
            required: ['value'],
          },
        },
        required: ['value', 'followUp'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'hs-31--1-5x',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 15720,
  sectionId: '2.2.9.7',
  impactArea: 'Worker Protection',
  impactAreaId: 'WORKER_PROTECTION',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
